export const SET_GLOBAL_ERROR = 'SET_GLOBAL_ERROR';

export const setGlobalError = value => ({
  type: SET_GLOBAL_ERROR,
  value
});